<template>
    <div class="clients">
      <div class="pageContent">
        <heading-wrap>
           <span slot="title">Invoices</span>
        </heading-wrap>

        <spinner v-if="loading" />
        <search-box v-model="search" name="invoices..." />
        <select v-model="statusFilter" @change="statusFilterCall" :style="{maxWidth: '10%', marginBottom: '1rem'}" class="form-control col-md-5 mr-sm-2">
          <option selected value="">Status</option>
          <option value="tsl_client">TSL Client</option>
          <option value="demo">Demo</option>
          <option value="trial">Trial</option>
          <option value="contract">Contract</option>
          <option value="deactivated">De-Activated</option>
        </select>

        <invoice-table :tableData="filteredInvoices" />
        <button v-if="!viewAllFlag" @click="viewAll" class="btn btn-warning">View all invoices</button>
      </div>
    </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import ButtonCta from '@/components/Button/button'
import SlotTable from '@/components/Table/table'
import Spinner from '@/components/SpinnerIcon/spinner'
import SearchBox from '@/components/SearchBox/searchbox'
import InvoiceTable from '@/components/InvoiceTable/invoice-table'
import {modalMixin} from '@/mixins/modalMixin'
import {invoiceMixin} from '@/mixins/invoiceMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

import moment from 'moment/moment'

import { assoc, map } from 'ramda'

export default {
  name: 'Invoices',
  mixins: [invoiceMixin, modalMixin, notificationMixin],
  components: {
    HeadingWrap,
    ButtonCta,
    SlotTable,
    Spinner,
    SearchBox,
    InvoiceTable
  },
  data: () => ({
    search: '',
    statusFilter: '',
    viewAllFlag: false
  }),
  computed: {
    filteredInvoices () {
      let formattedInvoices
      if (this.statusFilter) {
        formattedInvoices = map(item => assoc('invoicesActions', true, item), this.statusFilterCall())
      } else {
        formattedInvoices = map(item => assoc('invoicesActions', true, item), this.invoices)
      }
      return formattedInvoices.filter(invoice => {
        var searchDate = moment(invoice.period_start.value).format('MMM YYYY').toLowerCase()
        if (invoice.external_id !== null) {
          return invoice.client.name.toLowerCase().includes(this.search.toLowerCase()) || invoice.external_id.toLowerCase().includes(this.search.toLowerCase()) || searchDate.includes(this.search.toLowerCase())
        } else {
          return invoice.client.name.toLowerCase().includes(this.search.toLowerCase()) || searchDate.includes(this.search.toLowerCase())
        }
      })
    }
  },
  methods: {
    onRowMouseOver (event) {
      event.currentTarget.classList.add('clients--active')
    },
    onRowMouseLeave (event) {
      event.currentTarget.classList.remove('clients--active')
    },
    statusFilterCall () {
      if (this.statusFilter) {
        return this.invoices.filter(invoice => {
          return invoice.client.status === this.statusFilter
        })
      }
    },
    viewAll () {
      this.viewAllFlag = !this.viewAllFlag
      this.startLoading()
      this.getInvoices(1).then(() => {
        this.finishLoading()
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    }
  },
  created () {
    this.startLoading()
    this.getInvoices().then(() => {
      this.finishLoading()
    }, error => {
      this.finishLoading()
      this.addNotification('danger', error)
    })
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/invoice/invoices.vue